
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { siteUrl } from 'constants/app';
import SEO from 'global/SEO';
import dynamic from 'next/dynamic';

const MulaiInvestasi = dynamic(() => import('features/mulai-investasi'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

const MulaiInvestasiPage = () => (
  <HomePageLayout showFAQ whiteFooterBackground>
    <SEO
      title="Stockbit - Mulai Investasi Saham"
      url={`${siteUrl}/info/mulai-investasi`}
    />
    <MulaiInvestasi />
  </HomePageLayout>
);

export default MulaiInvestasiPage;
